import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=6a6987cf&lang=pug&"
import script from "./Publication.vue?vue&type=script&lang=ts&"
export * from "./Publication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports